var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeshLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 326,
    viewBox: "0 0 350 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_931_85)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.713 8.40151C231.151 4.12611 223.175 5.16942 218.9 10.7318L156.656 91.7129L152.633 96.9466L145.035 96.0487L40.2363 83.6634C33.2692 82.84 26.9537 87.8205 26.1303 94.7876C25.3069 101.755 30.2874 108.07 37.2546 108.894L134.347 120.368L155.742 177.853L139.944 201.68L138.393 204.019L137.972 206.794L137.442 210.287H80.9827C79.0422 210.287 77.2083 211.174 76.0036 212.695L7.09019 299.71C5.57787 301.62 5.29088 304.226 6.35147 306.419C7.41207 308.612 9.6334 310.005 12.0693 310.005H328.372C330.683 310.005 332.811 308.75 333.93 306.728C335.048 304.707 334.981 302.237 333.753 300.279L279.182 213.264C278.02 211.412 275.987 210.287 273.801 210.287H229.907C229.406 196.873 218.373 186.152 204.836 186.152C191.299 186.152 180.266 196.873 179.766 210.287H164.72L180.49 186.502L184.064 181.112L184.038 181.042L195.274 177.217L209.358 172.423L232.096 168.092L262.774 177.353C269.49 179.38 276.579 175.579 278.606 168.863C280.634 162.147 276.833 155.059 270.117 153.031L236.454 142.869L233.469 141.968L230.406 142.551L203.73 147.632L202.855 147.799L202.013 148.085L198.78 149.186L181.086 101.618L239.043 26.2144C243.319 20.652 242.275 12.6769 236.713 8.40151ZM180.33 216.639H162.175L156.104 256.653C155.051 263.589 148.575 268.359 141.639 267.307C134.703 266.254 129.933 259.778 130.985 252.842L136.478 216.639H80.9827L17.0995 297.302L12.0693 303.654H20.1714H320.875H328.372L324.389 297.302L273.801 216.639H229.342C226.873 227.9 216.839 236.328 204.836 236.328C192.834 236.328 182.8 227.9 180.33 216.639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_931_85",
    x: 0.717773,
    y: 0.769531,
    width: 349.006,
    height: 324.236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_931_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_931_85",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeshLogo);
export default __webpack_public_path__ + "static/media/sesh-logo.8a8456b69f710a75ccd99b9c5d0ac652.svg";
export { ForwardRef as ReactComponent };